(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-logo-list"] && !Shopify.designMode) return;
  try {
    

if (window.jQuery && jQuery.fn.slick && jQuery('.dgfdgfdgd').length) {
  jQuery('.dgfdgfdgd').slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
}




  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-abt-section"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  if ($.fn.slick && $('.cstm-sildes').length) {
    $('.cstm-sildes').slick();
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-review-section"] && !Shopify.designMode) return;
  try {
    
if (window.jQuery && jQuery.fn.slick && jQuery('.centered').length) {
  jQuery('.centered').slick({
    centerMode: true,
    centerPadding: '100px',
    centerMargin: '20px',
    slidesToShow: 3,
    speed: 600,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '80px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          centerMode: false,
          centerPadding: '0px',
          autoplay: false,
          slidesToShow: 1
        }
      }
    ]
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_video_review"] && !Shopify.designMode) return;
  try {
    
if (window.jQuery && jQuery.fn.slick && jQuery('.centeredvideo').length) {
  jQuery('.centeredvideo').slick({
    centerMode: true,
    centerPadding: '150px',
    centerMargin: '20px',
    slidesToShow: 3,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '80px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          centerPadding: '0px',
          autoplay: false,
          slidesToShow: 1
        }
      }
    ]
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  if ($.fn.slick && $('.feacturd').length) {
    $('.feacturd').slick({
      slidesToShow: 4,
      autoplay: false,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            arrows: true,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            autoplay: false,
            slidesToShow: 1
          }
        }
      ]
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-swipe-section"] && !Shopify.designMode) return;
  try {
    

if (window.jQuery && jQuery.fn.slick && jQuery('.swipes').length) {
  jQuery('.swipes').slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '35px'
        }
      }
    ]
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["program-benefits"] && !Shopify.designMode) return;
  try {
    
var click1 = document.getElementsByClassName("learn-more");

Array.from(click1).forEach(function (cl1) {
  cl1.addEventListener("click", function () {
    var benefitItem = this.closest(".benefit-item"); 
    if (benefitItem) {
      var allBenefitItems = document.querySelectorAll(".benefit-item");
      allBenefitItems.forEach(function(item) {
        if (item !== benefitItem) {
          item.classList.remove("flippped_class");
        }
      });
      benefitItem.classList.toggle("flippped_class"); 
    }
  });
});

var closeBtns = document.getElementsByClassName("close-btn");

Array.from(closeBtns).forEach(function (btn) {
  btn.addEventListener("click", function () {
    var benefitItem = this.closest(".benefit-item");
    if (benefitItem) {
      benefitItem.classList.remove("flippped_class"); 
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
